module.exports = Em.ObjectController.extend({
})
